import axios from "axios";
import ipConfig from "./ipconfig";
import router from "../router";
import { Message } from "element-ui";
import showMessage from '../utils/showMessage'
import { applySign, clearSignKey } from './sign'

// import { get } from "core-js/core/dict";

const request = axios.create({
    // baseURL:'http://192.168.1.101:8084',
    baseURL:ipConfig.baseUrl, 
    timeout:10000 ,
    headers:{'Content-Type':'application/x-www-form-urlencoded'},
    // headers: {'Content-Type': 'application/json;charset=utf-8'},
    // withCredentials: true
})

//请求拦截
request.interceptors.request.use(
    // config.headers['Access-Control-Allow-Credentials'] = true,
    config => {
    //这里根据项目的实际情况，可在请求时对自己的请求信息添加信息
    //比如在请求头中添加校验身份的token或uuid等内容
    if (localStorage.getItem('token')) {
        config.headers['chooseToken'] = localStorage.getItem('token')
    }
    // config.headers['Access-Control-Allow-Credentials'] = true
        return applySign(config)
    },
    error => {
        return Promise.reject(error)
    }
)
//响应拦截
request.interceptors.response.use(
    response => {
    const res = response.data;
    if(res.code == 11011 || res.code == 11012|| res.code == 11013) {
        showMessage(res.message)
        setTimeout(() => {
            sessionStorage.removeItem('token');
            localStorage.removeItem('token');
            clearSignKey();
            router.push({ path: '/' })
        }, 1000);
    }
    //这里可初步对响应体进行筛选
   //根据自己实际的后端项目返回内容的设计，比如在不同的状态下代表着不同的意思，可直接作出相应的事件
   //例如返回响应状态为200，这里可直接返回响应体中的data，不必返回全部的响应体
   //再或者状态位401，未登录，那就可以直接在这里写重定向到登录页面等等
    if(response.status === 200) {
        return response
    }else {
        console.log({
            message: response.statusText
        })
        return Promise.reject(new Error(response.statusText))
    }
    },
    // error => {
    //     console.log({
    //         message: error.message
    //     })
    //     return Promise.reject(error)
    // }
    ({ response }) => {const { status, data } = response 
     // const { message } = data
        // Message .error(message)
        if (status == '401'){
            showMessage('登录已过期，请重新登录')
            router.push({ path: '/' })
        } else if (status == '403'){
            showMessage('暂无权限')
        }
     return Promise.reject(error)
}
)



export default request 




// WEBPACK FOOTER //
// ./src/utils/xwwwrequest.js